var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 30580"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 1862",
    style: {
      strokeWidth: 2,
      stroke: "currentColor",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19834",
    d: "M892.019 191.7s2.244 5.322 6.468 7.43 8.731 2.262 8.463 6.539",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "currentColor",
      fill: "none"
    },
    transform: "translate(-885 -189)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19835",
    d: "M892.069 191.479c-1.254 2.353-1.443 4.185.667 6.533",
    transform: "translate(-887 -188)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "currentColor",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19836",
    d: "M899.337 203.986c1.771 1.645 6.9 2.674 5.744 4.934",
    transform: "translate(-887 -188)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "currentColor",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19837",
    d: "M889.528 204.178a8.911 8.911 0 0 0 6.078 4.672",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "currentColor",
      fill: "none"
    },
    transform: "translate(-885 -189)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 1863",
    transform: "rotate(30 6.268 28.259)",
    style: {
      strokeWidth: 2,
      stroke: "currentColor",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 3,
    rx: 2.5,
    ry: 2,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 1864",
    transform: "translate(13 19)",
    style: {
      stroke: "currentColor",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 1865",
    transform: "translate(7 11)",
    style: {
      strokeWidth: 2,
      stroke: "currentColor",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1,
    style: {
      fill: "none"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.efd7b974d98a8e1e1d4e527cec47aa8c.svg";
export { ForwardRef as ReactComponent };